export default __webpack_public_path__ + "static/media/ricardo-morais.6b551cad.png";